<template v-once>
  <img src="@/assets/icons/doceree_icon.svg" alt="doceree icon">
</template>

<script>
export default {
  name: "Doceree",
};
</script>

<style scoped>
</style>